import LinkToDocusaurus from '../LinkToDocusaurus'
import { models } from '../../docs-routes'

const LinkToModelsDoc = () =>
  <LinkToDocusaurus path={models}>
    Learn more about Models
  </LinkToDocusaurus>

export default LinkToModelsDoc
